import { libraryTab, shellSearch } from '../../data/state.js';

/** A Knowledge Base query always opens its fact results. */
export function updateLibrarySearch(query: string): void {
  shellSearch.value = query;
  if (query.trim() !== '') libraryTab.value = 'facts';
}
